export let option = {
	getText: (options, val) => {
		let item = options.find((v) => { return v.value === val; });
		return item ? item.text : '';
	},
	
	// 送货方式
	deliverymethods: [
		{ value: '1', text: '客户自提' },
		{ value: '2', text: '公司送货' },
	],
	
	
	// 获取用户
	getAdmins: async (obj, params) => {
	  let res = await obj.$post(obj.$api.admins, { page: params.page, nickname: params.query, ...obj.customParams  });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.nickname, value: item.id } } ) : [];
	},

	
	// 获取物流商
	getExpress: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stExpressSelect, { page: params.page, name: params.query, ...obj.customParams  });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.name, value: item.id } } ) : [];
	},
	
	// 获取币种
	getCurrency: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stCurrency, { page: params.page, currency_name: params.query });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.tcur, value: item.tcur } } ) : [];
	},
	
	
}

